<template>
  <div class="p-articleDetails">
    <div class="g-box">
      <!--返回上一页-->
      <div @click="goback" class="back m-h">
        <img src="../../assets/img/icon_back.png" />
        <p>返回上一页</p>
      </div>
      <!--内容-->
      <div class="nav">
        <div class="left">
          <p class="left_title">{{ info.title }}</p>
          <p class="left_time">{{ info.publishTime }}</p>
          <iframe
            v-if="info.contentType === '链接'"
            class="my-iframe"
            ref="iframe"
            src="https://mp.weixin.qq.com/s/ERayksDRmD3pdnv3Lj3tHg"
            name="ifr"
            allow="payment"
            allowpaymentrequest="true"
            frameborder="0"
          ></iframe>
          <!-- <object
            v-if="info.url"
            data="https://wechat.kefang.net/s/ERayksDRmD3pdnv3Lj3tHg"
            type="text/html"
            width="500px"
            height="500px"
          ></object> -->

          <div v-else class="left_text" v-html="info.content"></div>
        </div>
        <div class="right">
          <div class="right_title">
            <div class="line_Y"></div>
            <p class="right_title_text">相关内容</p>
          </div>
          <div class="line_X"></div>
          <div class="right_nav" v-for="item in dataList" :key="item.id">
            <div class="dian"></div>
            <!-- <div class="right_text" @click="toDetail(item)">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top-start"
              >
                <span>{{ item.title }}</span>
              </el-tooltip>
            </div> -->
            <router-link
              :to="'/article_details/' + item.id + '?' + new Date().getTime()"
              class="right_text"
              target="_self"
            >
              <span>{{ item.title }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataList: [],
      info: {}
    };
  },
  watch: {
    $route() {
      this.init();
    }
  },
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      this.getInfo();

      this.$api.cms.web.siteContent_listCorrelation
        .get({
          id: this.params.menuId
        })
        .then(res => {
          this.dataList = res.data.pageList;
          // console.log(res.data, "dataa");
        });
      // const list = localStorage.getItem("dataList");
      // this.list = JSON.parse(list);
      // console.log(this.list, "list");
    },
    goback() {
      window.history.back();
    }
  }
};
</script>
<style lang="less" scoped>
.back {
  display: flex;
  align-items: center;
  margin-top: 61px;
  margin-bottom: 41px;
  p {
    width: 80px;
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #656878;
    line-height: 22px;
  }
}
.nav {
  display: flex;
  justify-content: space-between;
  padding-bottom: 120px;
}
.left {
  width: 640px;
}
.left_title {
  font-size: 32px;
  font-weight: 600;
  color: #000000;
  line-height: 45px;
  margin-bottom: 20px;
  line-height: 1;
}
.left_time {
  font-size: 14px;
  font-weight: 400;
  color: #656878;
  line-height: 20px;
  margin-bottom: 40px;
}
.left_text {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
  margin-bottom: 20px;
}
.my-iframe {
  width: 100%;
  height: 500px;
}
.left_img_text {
  width: 84px;
  height: 17px;
  font-size: 12px;
  font-weight: 400;
  color: #a8aab8;
  line-height: 17px;
  margin-bottom: 20px;
  text-align: center;
}

.img {
  width: 640px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.right {
  .line {
    width: 2px;
    height: 16px;
    background: #0030aa;
  }
}
.right_title {
  display: flex;
  align-items: center;
  .line_Y {
    width: 2px;
    height: 16px;
    background: #0030aa;
  }
  .right_title_text {
    width: 64px;
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #0030aa;
    line-height: 22px;
    margin-left: 10px;
  }
}
.line_X {
  width: 320px;
  height: 1px;
  background: #e3e3e7;
  margin: 20px 0;
}
.right_nav {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .dian {
    width: 4px;
    height: 4px;
    background: #0030aa;
    margin-right: 10px;
  }
  .right_text {
    width: 306px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #656878;
    line-height: 20px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .right_text:hover {
    color: #0030aa;
  }
}
</style>
